{
  "title": "Crown of Madness",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level enchantment",
  "level": 2,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "One humanoid of your choice that you can see within range must succeed on a Wisdom saving throw or become charmed by you for the duration. While the target is charmed in this way, a twisted crown of jagged iron appears on its head, and a madness glows in its eyes.",
    "The charmed target must use its action before moving on each of its turns to make a melee attack against a creature other than itself that you mentally choose. The target can act normally on its turn if you choose no creature or if none are within its reach.",
    "On your subsequent turns, you must use your action to maintain control over the target, or the spell ends. Also, the target can make a Wisdom saving throw at the end of each of its turns. On a success, the spell ends."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
